import { subject } from "@casl/ability";
import { ActionIcon } from "@mantine/core";
import { IconCopy } from "@tabler/icons-react";
import { createColumnHelper } from "@tanstack/react-table";
import useUserStore from "@/modules/users/store";
import { CopyEmbaixadorUrlButton } from "../copy-embaixador-url-button";
import ContextMenuRow from "./ContextMenuRow";
import useGetProjetosByEmbaixador from "../../hooks/useGetProjetosByEmbaixador";

const columnHelper = createColumnHelper<TEmbaixadorPessoa>();

export const columns = [
  columnHelper.accessor("nome", {
    header: "Nome",
    enableSorting: true
  }),

  columnHelper.accessor("telefone", {
    header: "Telefone",
    cell: ({ getValue }) => getValue() || "-"
  }),

  columnHelper.accessor("email", {
    header: "Email",
    cell: ({ getValue }) => getValue() || "-"
  }),

  columnHelper.display({
    header: "Link do Embaixador",
    id: "copy-url",
    cell: function Cell({ row }) {
      const activeProjeto = useUserStore((state) => state.activeProjeto);
      const { data: projetosDoEmbaixador } = useGetProjetosByEmbaixador(row.original.id);

      const isAssociatedWithActiveProject = projetosDoEmbaixador?.some((projeto) => projeto.id === activeProjeto);

      return (
        <ActionIcon
          component={CopyEmbaixadorUrlButton}
          embaixador={row.original}
          disabled={!activeProjeto || !isAssociatedWithActiveProject}
        >
          <IconCopy size="1rem" />
        </ActionIcon>
      );
    }
  }),

  columnHelper.display({
    id: "actions",
    cell: ({ row }) => {
      const item = subject("TEmbaixadorPessoa", row.original);
      return <ContextMenuRow item={item} />;
    }
  })
];
